export default {
  methods: {
    haveDublicated: function (id) {
      const dublicated = [...this.allAttachments].some((attachment) => attachment?.id === id);
      return dublicated;
    },
    addNewAttachment: function (newAttachment) {
      if (!this.haveDublicated(newAttachment?.id))
        this.allAttachments = [...this.allAttachments, newAttachment];
      else return;
    },
    deleteAttachment: function (id) {
      const filterdAttachments = [...this.allAttachments].filter(
        (attachment) => attachment?.id !== id,
      );
      this.allAttachments = [...filterdAttachments];
    },
    clearAttachments: function () {
      this.allAttachments = [];
    },
  },
};
